<template>
<div class="dashboard-box">
  <Search></Search>
  <div class="dashboard-content" v-loading="loading">
    <div class="left">
      <Deal :dataInfo="dashboardData.deal"></Deal>
      <Ticket :dataInfo="dashboardData.ticket" class="mt-20"></Ticket>
    </div>
    <div class="right">
      <Asset :dataInfo="dashboardData.asset"></Asset>
    </div>
  </div>
</div>
</template>

<script>
import Search from './Search'
import Deal from './Deal'
import Ticket from './Ticket'
import Asset from './Asset'
import Bus from '@/common/vueBus'
import lodash from 'lodash'
export default {
  name: 'Index',
  data () {
    return {
      dashboardData: {},
      loading: false
    }
  },
  components: {
    Search,
    Deal,
    Ticket,
    Asset
  },
  created () {
    Bus.$off('changeSearch')
    Bus.$on('changeSearch', (val) => {
      this.getDashboardInfo(val)
    })
  },
  methods: {
    getDashboardInfo: lodash.debounce(function (val) {
      const params = {
        assetOwner: val.service,
        startDate: val.startTime,
        endDate: val.endTime
      }
      if (val.selectedType.includes('platform')) {
        params.platforms = val.selectedValues && val.selectedValues.length > 0 ? val.selectedValues.join(',') : ''
        params.types = ''
      } else {
        params.platforms = ''
        params.types = val.selectedValues && val.selectedValues.length > 0 ? val.selectedValues.join(',') : ''
      }
      this.loading = true
      this.$axios
        .post('/rental-forecasting/asset/dashboard', params, {
          isCancelToken: true
        })
        .then(res => {
          if (res.data.errorInfo && res.data.errorInfo.includes('权限不足')) {
            this.$message.error(res.data.errorInfo)
            return
          }
          this.dashboardData = res.data
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
        })
    }, 500)
  }
}
</script>

<style scoped lang="less">
.dashboard-box {
  width: 100%;
  .dashboard-content {
    margin-top: 24px;
    display: flex;
    .left {
      width: 50%;
      margin-left: 24px;
      padding-right: 16px;
      border-right: 4px dashed #444;
    }
    .right {
      width: 50%;
      margin-left: 16px;
    }

  }
}
</style>
